import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var CustomersFilled = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("g", {
    clipPath: "url(#clip0_3_8280)"
  }, React__default.createElement("path", {
    d: "M5.00016 1.66666C4.07933 1.66666 3.3335 2.41249 3.3335 3.33332V5.83332H16.6668V3.33332C16.6668 2.41249 15.921 1.66666 15.0002 1.66666H5.00016ZM3.3335 7.49999V12.5H11.7075C11.9117 10.6033 13.4568 9.16666 15.4168 9.16666C15.8593 9.16666 16.2752 9.25464 16.6668 9.38964V7.49999H3.3335ZM15.4168 10.8333C14.8643 10.8333 14.3344 11.0528 13.9437 11.4435C13.553 11.8342 13.3335 12.3641 13.3335 12.9167C13.3335 13.4692 13.553 13.9991 13.9437 14.3898C14.3344 14.7805 14.8643 15 15.4168 15C15.9694 15 16.4993 14.7805 16.89 14.3898C17.2807 13.9991 17.5002 13.4692 17.5002 12.9167C17.5002 12.3641 17.2807 11.8342 16.89 11.4435C16.4993 11.0528 15.9694 10.8333 15.4168 10.8333ZM3.3335 14.1667V16.6667C3.3335 17.5875 4.07933 18.3333 5.00016 18.3333H9.28239C9.63489 16.9983 10.8543 15.9428 12.6076 15.402C12.2934 15.0453 12.0507 14.6258 11.8882 14.1667H3.3335ZM15.4168 16.6667C12.9135 16.6667 10.8335 17.6758 10.8335 19.1308V20H20.0002V19.1308C20.0002 17.6758 17.9202 16.6667 15.4168 16.6667Z",
    fill: fill
  })), React__default.createElement("defs", null, React__default.createElement("clipPath", {
    id: "clip0_3_8280"
  }, React__default.createElement("rect", {
    width: "20",
    height: "20",
    fill: "white"
  }))));
};
export { CustomersFilled as default };
//# sourceMappingURL=CustomersFilled.js.map
